import { useState } from "react";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import { Paper, Tabs } from "@mantine/core";
import TransportConfiguration from "./TransportConfiguration/TransportConfiguration";
import PersonnelConfigurationForGoodsManagement from "./PersonnelConfigurationForGoodsManagement/PersonnelConfigurationForGoodsManagement";
import DistanceFare from "./DistanceFare/DistanceFare";
import ConfigDeliveryXfast from "./ConfigDeliveryXfast/ConfigDeliveryXfast";

const TabListDeliveryConfig = () => {
  const [activeTab, setActiveTab] = useState<string | null>(
    "transportConfiguration",
  );

  return (
    <>
      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "0px 10px",
        }}
      >
        <BreadcrumbLayout1></BreadcrumbLayout1>
      </div>
      <Paper shadow="md" radius="lg">
        <Tabs p={"xs"} value={activeTab} onChange={setActiveTab}>
          <Tabs.List>
            <Tabs.Tab value="transportConfiguration">Cấu hình loại GV</Tabs.Tab>
            <Tabs.Tab value="configDeliveryXfast">
              Cấu hình giao vận Xfast
            </Tabs.Tab>
            <Tabs.Tab value="personnelConfigurationForGoodsManagement">
              Cấu hình nhân sự quản lý hàng hóa cho GV
            </Tabs.Tab>
            <Tabs.Tab value="distanceFare">
              Cấu hình tính lương theo khoảng cách
            </Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="transportConfiguration">
            {activeTab === "transportConfiguration" ? (
              <TransportConfiguration />
            ) : (
              <></>
            )}
          </Tabs.Panel>
          <Tabs.Panel value="configDeliveryXfast">
            {activeTab === "configDeliveryXfast" ? (
              <ConfigDeliveryXfast />
            ) : (
              <></>
            )}
          </Tabs.Panel>
          <Tabs.Panel value="personnelConfigurationForGoodsManagement">
            {activeTab === "personnelConfigurationForGoodsManagement" ? (
              <PersonnelConfigurationForGoodsManagement />
            ) : (
              <></>
            )}
          </Tabs.Panel>
          <Tabs.Panel value="distanceFare">
            {activeTab === "distanceFare" ? <DistanceFare /> : <></>}
          </Tabs.Panel>
        </Tabs>
      </Paper>
    </>
  );
};

export default TabListDeliveryConfig;
